module.exports = __webpack_public_path__ + "img/visa.ee65c7e5.svg";